import { Switch } from 'components/common'
import { Control, Controller, FieldValues, Path } from 'react-hook-form'

type Props<T extends FieldValues> = {
  control: Control<T>
  name: Path<T>
  label: string
  description?: string
  disabled?: boolean
  defaultValue?: boolean
  showStatusPill?: boolean
}

const SwitchField = <T extends FieldValues>({
  control,
  name,
  label,
  description,
  disabled = false,
  defaultValue = false,
  showStatusPill = false,
}: Props<T>) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue as any}
      render={({ field }) => {
        const isActive = Boolean(field.value)

        return (
          <div className="flex items-center justify-between gap-4 py-2">
            <div>
              <p className="text-sm font-medium text-primary">{label}</p>
              {description && (
                <p className="text-xs text-gray-500">{description}</p>
              )}
            </div>

            <div className="flex shrink-0 items-center gap-3">
              {showStatusPill && (
                <span
                  className={`rounded-full px-2.5 py-1 text-xs font-medium ${
                    isActive
                      ? 'bg-green-100 text-green-700'
                      : 'bg-gray-100 text-gray-500'
                  }`}
                >
                  {isActive ? 'Active' : 'Inactive'}
                </span>
              )}

              <Switch
                checked={isActive}
                disabled={disabled}
                onChange={field.onChange}
                className="shrink-0"
              />
            </div>
          </div>
        )
      }}
    />
  )
}

export default SwitchField
